/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      const gradeQuiz = {
        pass: function( userId, courseId ) {
          // ajax call to save course to users "Completed Courses"
          let doingAjax = true;
          const data = {
            'user_id': userId,
            'course_id': courseId,
          };

          $.ajax( {
            type: 'GET',
            url: site_info.wpApiSettings.ll + 'cpt/passUserCourse',
            data: data,
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {

            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
            },
          } );
          // hide form
          $( '.grade-form .grading-actions' ).hide();
          // show confirmation message
          $( '.grade-form .user-passed' ).show();
        },
        fail: function( userId, courseId ) {
          // ajax call to save course to users "Failed Courses"
          let doingAjax = true;
          const data = {
            'user_id': userId,
            'course_id': courseId,
          };

          $.ajax( {
            type: 'GET',
            url: site_info.wpApiSettings.ll + 'cpt/failUserCourse',
            data: data,
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {

            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
            },
          } );
          // hide form
          $( '.grade-form .grading-actions' ).hide();
          // show confirmation message
          $( '.grade-form .user-failed' ).show();
        },
      };

      $( '.grade-form .pass-quiz' ).on( 'click', function() {
        gradeQuiz.pass( $( this ).attr( 'data-user' ), $( this ).attr( 'data-course' ) );
      } );

      $( '.grade-form .fail-quiz' ).on( 'click', function() {
        gradeQuiz.fail( $( this ).attr( 'data-user' ), $( this ).attr( 'data-course' ) );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'grade-form', COMPONENT );
} )( app );
